import React from 'react';

import { Form } from 'react-bootstrap';
import { useField, useFormikContext } from 'formik';
import { DateTime } from 'luxon';

import { DatePicker } from 'components/UI';

type IDatePickerVariant = 'primary' | 'form';

interface IDatePickerFieldProps {
  name: string;
  label?: string;
  required?: boolean;
  variant?: IDatePickerVariant;
  maxTime?: Date;
  dataTestId?: string;
  disabled?: boolean;
  [x: string]: any;
}

const DatePickerField = ({
  name,
  label,
  required,
  variant = 'form',
  maxTime,
  dataTestId,
  ...props
}: IDatePickerFieldProps) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField({ name });

  field.onChange = (val: any) => {
    let newValue = val;
    if (maxTime && DateTime.fromJSDate(val).toMillis() >= DateTime.fromJSDate(maxTime).toMillis()) {
      newValue = DateTime.now().toJSDate();
    }
    setFieldValue(field.name, newValue);
    helpers.setTouched(true, false);
  };

  return (
    <>
      {label && (
        <Form.Label>
          {label} {required ? '*' : ''}
        </Form.Label>
      )}
      <DatePicker
        dataTestId={dataTestId}
        selected={(field.value && new Date(field.value)) || null}
        {...field}
        {...props}
        className={`${props.className} form-control p-0 ${
          variant === 'form' && 'form-date-picker'
        }`}
        disabled={props.disabled}
      />
      {meta.touched && meta.error && (
        <Form.Control.Feedback className="d-block" type="invalid">
          {meta.error}
        </Form.Control.Feedback>
      )}
    </>
  );
};

export default DatePickerField;
